/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Remove_Tag_LabelInputs */



/**
* | output |
* | --- |
* | "Remove Tag" |
*
* @param {Tags_Manager_Remove_Tag_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_tag_label = /** @type {((inputs?: Tags_Manager_Remove_Tag_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Tag_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le tag")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить тег")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar etiqueta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover etiqueta")
	return /** @type {LocalizedString} */ ("Remove Tag")
});